import script from "./Tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=ee18a17e&lang=css"

const __exports__ = script;

export default __exports__